module.exports = __webpack_public_path__ + "static/feeling-e22f7cfecf62b332802c3e9a7828651f.jpg";